var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("v-container", { attrs: { "grid-list-xl": "" } }, [
        _c("div", { staticClass: "text-center mt-5" }, [
          _c("h2", [_vm._v("Kellnerruf")]),
          _vm.selectedService.length > 0
            ? _c("h3", { staticClass: "mb-8" }, [
                _vm._v('"' + _vm._s(_vm.selectedService) + '"'),
              ])
            : _vm._e(),
          _vm.currentStep === 1
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "spacer-15" }),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md4: "" } },
                        [
                          _c("CategoryCard", {
                            staticClass: "pointer",
                            attrs: {
                              label: "Zahlung bar",
                              nomargin: false,
                              icon: "mdi-cash",
                            },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.clickPayOption("Zahlung bar")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md4: "" } },
                        [
                          _c("CategoryCard", {
                            staticClass: "pointer",
                            attrs: {
                              label: "Zahlung Kreditkarte",
                              nomargin: false,
                              icon: "mdi-credit-card",
                            },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.clickPayOption("Zahlung Kreditkarte")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md4: "" } },
                        [
                          _c("CategoryCard", {
                            staticClass: "pointer",
                            attrs: {
                              label: "Zahlung EC-Karte",
                              nomargin: false,
                              icon: "mdi-credit-card-outline",
                            },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.clickPayOption("Zahlung EC-Karte")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "", md4: "" } },
                        [
                          _c("CategoryCard", {
                            staticClass: "pointer",
                            attrs: {
                              label: "Kellner rufen",
                              nomargin: false,
                              pngicon: "waiter",
                              inverse: true,
                            },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.signal("Kellner bitte")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("tischnummer-dialog", {
        attrs: { dialog: _vm.showTischnummer },
        on: {
          tnumberselected: _vm.tnumberselected,
          close: function ($event) {
            _vm.showTischnummer = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }